// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://kfihtdedyfcfoonypgui.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImtmaWh0ZGVkeWZjZm9vbnlwZ3VpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjY5NDU5ODEsImV4cCI6MjA4MjUyMTk4MX0.AJ-CqUVV6KQ7RI9ziJj4tycVpIcRg1s9Znlj2il_HKc";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  }
});